<template>
  <div id="app" class="min-app">
    <div id="nav">
      <header-component />
    </div>
    <main>
      <router-view />
    </main>
  </div>
</template>

<script>
import header from "@/components/SiteComponents/header/header.vue";

export default {
  components: {
    headerComponent: header
  }
};
</script>
<style scoped>
.min-app {
  min-width: auto;
}
@media (min-width: 900px) {
  .min-app {
    min-width: 1280px;
  }
}
</style>
